import { Component, Host, h, Prop, State } from '@stencil/core';
import AsyncValidator from "async-validator";
import { formTagNamesMap, getPropByPath, noop } from "./utils";
// import {debounce} from "../../utils/utils"
// import {slotAssignedElements} from "../../utils/dom"
import { IFormProps, Rules } from "./type";

@Component({
  tag: 'jackery-form-item',
  styleUrl: 'jackery-form-item.css',
  shadow: true,
})
export class JackeryFormItem {
  @Prop() prop: string;
  @Prop() label: string = "";
  @Prop() labelwidth: string = "";
  @Prop() hidemessage?: "hide" | "" = "";
  @Prop() hideasterisk?: "hide" | "" = ""; // 是否隐藏必填 *
  @Prop() islink?: "link" | "";

  @State() validateState: string = "";
  @State() validateMessage: string = "";
  @State() validateDisabled: boolean = false;
  @State() itemNode: any = null;
  @State() formRules: Rules | null = null;
  rules: Rules | null = null;
  @State() formProps: IFormProps = {
    hideasterisk: false,
    hidemessage: false,
    labelwidth: "",
    labelsuffix: "",
    labelposition: "left",
  };
  @State() formModel: any = null;
  @State() initialValue: any = null; // 记录表单初始值，用于reset


  setFormProps(props: IFormProps) {
    this.formProps = props;
  }

  setFormModel(model) {
    if (!model || !this.prop) return;
    this.formModel = model;
    this.initialValue = getPropByPath(model, this.prop, true).v;
  }

  setRule(rule: Rules) {
    this.formRules = rule;
  }

  getRules(): Rules[] {
    const selfRules = this.rules;
    let formRules = this.formRules;
    if (formRules) {
      const prop = getPropByPath(formRules, this.prop || "", true);
      formRules = formRules ? prop.o[this.prop || ""] || prop.v : [];
    }
    return [].concat(selfRules || formRules || []);
  }

  clearValidate() {
    this.validateState = "";
    this.validateMessage = "";
    this.validateDisabled = false;
  }

  resetField() {
    this.validateState = "";
    this.validateMessage = "";

    const prop = getPropByPath(this.formModel, this.prop, true);
    this.validateDisabled = true;
    if (Array.isArray(this.initialValue)) {
      prop.o[prop.k] = [].concat(this.initialValue);

      // uploader 恢复默认值
      if (this.itemNode.tagName === formTagNamesMap["QUARK-UPLOADER"]) {
        const value = this.initialValue.map((item) => item.url || item.content);
        this.itemNode.setPreview(value);
      }
    } else {
      prop.o[prop.k] = this.initialValue;
    }

    setTimeout(() => {
      this.validateDisabled = false;
    }, 0);
  }

  validate(callback = noop) {
    this.validateDisabled = false;

    const rules = this.getRules();

    if (!rules || rules.length === 0) {
      callback();
      return true;
    }

    this.validateState = "validating";

    const validator = new AsyncValidator({ [this.prop]: rules });
    validator.validate(
      { [this.prop]: this.getValue() },
      { firstFields: true },
      (errors, invalidFields) => {
        this.validateState = !errors ? "success" : "error";
        this.validateMessage = errors ? errors[0].message : "";
        callback(this.validateMessage, invalidFields);
      }
    );
  }

  getValue = () => {
    if (!this.prop) return;
    let value = null;
    if (this.itemNode) {
      const tagName = this.itemNode.tagName;
      if (
        tagName === formTagNamesMap["QUARK-RADIO"] ||
        tagName === formTagNamesMap["QUARK-CHECKBOX"] ||
        tagName === formTagNamesMap["QUARK-SWITCH"]
      ) {
        value = this.itemNode.checked;
      } else if (tagName === formTagNamesMap["QUARK-UPLOADER"]) {
        value = this.itemNode.values;
      } else {
        value = this.itemNode.value;
      }
    }
    if (this.formModel) {
      const prop = getPropByPath(this.formModel, this.prop, true);
      if (Array.isArray(value)) {
        prop.o[prop.k] = [].concat(value);
      } else {
        prop.o[prop.k] = value;
      }
    }
    return value;
  }


  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
